module.exports = __webpack_public_path__ + "static/media/Logotipo ASCG.a74a0075.png";